import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpWalletAccountBindingCallbackCollectionResponse } from '../../../data/repository/fs-wallet-account/http-fs-wallet-account.collection';
import { UseCase } from '../../base/usecase';
import { FSWalletAccountRepository } from '../../repository/fs-wallet-account.repository';
import { BindingCallbackDTO } from './interface/binding-callback.dto';

@Injectable({
  providedIn: 'root',
})
export class BindWalletCallbackUsecase
  implements
    UseCase<BindingCallbackDTO, HttpWalletAccountBindingCallbackCollectionResponse>
{
  constructor(private repository: FSWalletAccountRepository) {}

  execute(
    data: BindingCallbackDTO
  ): Observable<HttpWalletAccountBindingCallbackCollectionResponse> {
    return this.repository.WalletBindingCallback(data);
  }
}
